import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

const RenderTextFieldRedux = ({ input, label, name, type, withFocus, autoFocus, maxLength, textTransform, meta: { touched, error } }) => {
  return (
    <div>
      <TextField
        {...input}
        type={!type ? "text" : type}
        fullWidth
        autoFocus={autoFocus}
        autoComplete="off"
        InputLabelProps={
          {
            // style: { color: '#000000' }
          }
        }
        inputProps={
          (type === 'number') ?
            {} :
            {
              maxLength: maxLength !== undefined && maxLength
            }
        }
        label={label}
      />
      {touched && error && <span style={{ color: 'red' }}>{error}</span>}
    </div>
  );
};

RenderTextFieldRedux.propTypes = {
  label: PropTypes.string.isRequired,
};

export default RenderTextFieldRedux;
